module.exports = __webpack_public_path__ + "img/menu-schedule.eba7ad05.svg";